import { serverCall } from "../modules/ServerComms";

function getNotificationActivities(payload, theCallback, theJWTToken) {
    const API_URL = `/api/admin/notifications/fetchNotificationActivities`;

    serverCall(
        "POST",
        API_URL,
        payload,
        function (resStatus, resJson) {
            let responseString;
            if (resStatus == "200" || resStatus == 200) {
                if (resJson.message) {
                    responseString = resJson.message;
                }
                return theCallback(resStatus, responseString, resJson);
            } else {
                return theCallback(resStatus, resJson.message, false);
            }
        },
        theJWTToken,
    );
}

function getNotificationActivityLogs(payload, theCallback, theJWTToken) {
    const API_URL = `/api/admin/notifications/fetchNotificationActivityLogs`;

    serverCall(
        "POST",
        API_URL,
        payload,
        function (resStatus, resJson) {
            let responseString;
            if (resStatus == "200" || resStatus == 200) {
                if (resJson.message) {
                    responseString = resJson.message;
                }
                return theCallback(resStatus, responseString, resJson);
            } else {
                return theCallback(resStatus, resJson.message, false);
            }
        },
        theJWTToken,
    );
}

function getDailyNotificationActivityLogs(payload, theCallback, theJWTToken) {
    const API_URL = `/api/admin/notifications/dailyNotificationActivityLogs`;

    serverCall(
        "POST",
        API_URL,
        payload,
        function (resStatus, resJson) {
            let responseString;
            if (resStatus == "200" || resStatus == 200) {
                if (resJson.message) {
                    responseString = resJson.message;
                }
                return theCallback(resStatus, responseString, resJson);
            } else {
                return theCallback(resStatus, resJson.message, false);
            }
        },
        theJWTToken,
    );
}

function getMonthlyNotificationActivityLogs(payload, theCallback, theJWTToken) {
    const API_URL = `/api/admin/notifications/monthlyNotificationActivityLogs`;

    serverCall(
        "POST",
        API_URL,
        payload,
        function (resStatus, resJson) {
            let responseString;
            if (resStatus == "200" || resStatus == 200) {
                if (resJson.message) {
                    responseString = resJson.message;
                }
                return theCallback(resStatus, responseString, resJson);
            } else {
                return theCallback(resStatus, resJson.message, false);
            }
        },
        theJWTToken,
    );
}

function getNotificationActivityDetails(payload, theCallback, theJWTToken) {
    const API_URL = `/api/admin/notifications/fetchNotificationActivity`;

    serverCall(
        "POST",
        API_URL,
        payload,
        function (resStatus, resJson) {
            let responseString;
            if (resStatus == "200" || resStatus == 200) {
                if (resJson.message) {
                    responseString = resJson.message;
                }
                return theCallback(resStatus, responseString, resJson);
            } else {
                return theCallback(resStatus, resJson.message, false);
            }
        },
        theJWTToken,
    );
}

function getNotificationChannels(payload, theCallback, theJWTToken) {
    const API_URL = `/api/admin/notifications/fetchNotificationChannels`;

    serverCall(
        "POST",
        API_URL,
        payload,
        function (resStatus, resJson) {
            let responseString;
            if (resStatus == "200" || resStatus == 200) {
                if (resJson.message) {
                    responseString = resJson.message;
                }
                return theCallback(resStatus, responseString, resJson);
            } else {
                return theCallback(resStatus, resJson.message, false);
            }
        },
        theJWTToken,
    );
}

export {
    getNotificationActivities,
    getNotificationActivityLogs,
    getDailyNotificationActivityLogs,
    getMonthlyNotificationActivityLogs,
    getNotificationActivityDetails,
    getNotificationChannels,
};
